import React from 'react';
import styled from 'styled-components';
import { Text } from '@solvhealth/jigsaw-v1';
import { ToggleButton } from './index';
import { isEmpty } from '../../../../../../core/util/empty';

const ToggleContainer = styled.div.withConfig({ componentId: 'sc-v7srwd-0' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

type OwnProps = {
  defaultSelectedToggleIndex?: number;
  headerTitle?: string;
  toggleOptions: any[];
  /** data-testid values for each toggle button */
  buttonTestIds?: string[];
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof ToggleGroup.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'ToggleGroup' implicitly has type 'any' because it... Remove this comment to see the full error message
const ToggleGroup = (props: Props) => {
  const { headerTitle, toggleOptions } = props;

  // making toggle option width dynamic so that we can pass in varying numbers of options in the future
  const toggleOptionWidth = `${100 / toggleOptions.length - 2}%`;

  if (isEmpty(toggleOptions)) return null;

  return (
    <>
      {headerTitle && (
        <Text mb={0.5} mt={3} title={headerTitle} variant="subtitle2">
          {headerTitle}
        </Text>
      )}

      <ToggleContainer>
        {toggleOptions.map((option: any, i: any) => (
          <ToggleButton
            dataTestId={props.buttonTestIds?.[i]}
            icon={option.icon}
            isSelected={option.isSelected}
            key={option.copy}
            onClick={option.onClick}
            title={option.copy}
            width={toggleOptionWidth}
          />
        ))}
      </ToggleContainer>
    </>
  );
};

ToggleGroup.defaultProps = {
  defaultSelectedToggleIndex: 0,
};

export default ToggleGroup;
